import i18n from 'i18next';
import { initReactI18next, useTranslation } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import { translations } from './translations.js';

const initializeI18n = (translations$1, currentLanguage) => {
    i18n
        .use(LanguageDetector)
        .use(initReactI18next)
        .init({
        lng: currentLanguage || "en-US",
        fallbackLng: "en-US",
        debug: false,
        interpolation: {
            escapeValue: false,
        },
        resources: translations$1 || translations,
    });
    return i18n;
};
const useLocalizedString = () => {
    const { t, i18n } = useTranslation();
    return { t, i18n };
};

export { initializeI18n as default, initializeI18n, useLocalizedString };
